import { useDispatch } from 'react-redux'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import { actions } from '../../InventoryState'

export default ({
  open, setOpen, badgeToDelete,
}) => {
  const dispatch = useDispatch()

  const onConfirmModal = () => {
    dispatch(actions.deleteBadge({ badgeToDelete }))
    dispatch(actions.getBadges())
    setOpen(false)
  }

  return (
    <ConfirmOrRejectModal
      show={open}
      title='Deletar crachá'
      description={`Você tem certeza que deseja deletar o crachá ${badgeToDelete}?`}
      onConfirm={() => onConfirmModal()}
      onReject={() => setOpen(false)}
      onClose={() => setOpen(false)}
    />
  )
}
